var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrees1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 295,
    viewBox: "0 0 106 295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trees-1",
    transform: "translate(-368 -4071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2994",
    "data-name": "Rectangle 2994",
    d: "M53,0h53a0,0,0,0,1,0,0V163a53,53,0,0,1-53,53h0A53,53,0,0,1,0,163V53A53,53,0,0,1,53,0Z",
    transform: "translate(368 4071)",
    fill: "#c4d5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3012",
    "data-name": "Path 3012",
    d: "M7.5,0A7.5,7.5,0,0,1,15,7.5v168a7.5,7.5,0,0,1-15,0V7.5A7.5,7.5,0,0,1,7.5,0Z",
    transform: "translate(414 4183)",
    fill: "#4e4d4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M3,34.717a2,2,0,0,1,3.993,0l2.882,50.1a2,2,0,0,1-2,2.115H2.118a2,2,0,0,1-2-2.115Z",
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 382.909, 4204.156)",
    fill: "#4e4d4b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrees1);
export default __webpack_public_path__ + "static/media/trees-1.e888058cf114600306613178983b2797.svg";
export { ForwardRef as ReactComponent };